import React, {useEffect,useContext,useRef,useState} from 'react';
import { DataContext } from 'contexts/DataContext';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import EditableGrid from 'components/EditableGrid/EditableGrid';
import Typography from '@mui/material/Typography';
import Department from './Department';
import Business from '@mui/icons-material/Business';
import Add from '@mui/icons-material/Add';
import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { get, update, destroy, getColumns } from './api'

function Organization() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const [columns, setColumns] = useState([] as GridColDef[]);
  const addButtonRef = useRef(null);
  useEffect(() => {
    if(dataContext.loading) return;
    getColumns(dataContext.language).then((response) => {
      setColumns(response);
    });
  }, [dataContext.loading, dataContext.language]);


  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
    title={<><Typography variant='pageTitle'>{t('Organization')}</Typography></>}
    actions={[
      {
        label: t('Add organization'),
        icon:<Add />,
        action: () => {
          let addbutton = addButtonRef.current as any;
          addbutton.click();
        }
      }
    ]}
    >
      <EditableGrid addButtonRef={addButtonRef} hideAddButton={true} details={Department} columns={columns} get={get} update={update} delete={destroy}
        reloadParentOnEditStop={true}
        name='organizationGrid'
        labels={{
          "actions": t('Actions'),
          "add": {
            "button": t('Add organization')
          },
          "details": {
            "column":t('Departments'), 
            "button":t('View')
          }
        }} />
    </AppLayout>
  );
}

export default Organization;
